export default __webpack_public_path__ + "assets/images/7fea6d461fc23fd1428ec0c837d59bcd.png";